export const fetch_sessions_list_api = "eud/sessions/booked/list";
export const fetch_sessions_metadata_api = "eud/sessions/metadata/get";
